// 生产环境
let config = {
  // baseUrl: 'http://localhost:8082', // 生产网关地址
  // baseUrl: 'http://crm.shanxiyixue.com:8082', // 生产网关地址
  baseUrl: 'https://tdxl.hbucm.edu.cn/gateway',
  // baseUrl: 'http://192.168.10.22:9900',
  // baseUrl: 'http://192.168.10.118:8082',
  // url: 'crm.shanxiyixue.com',
  url: '192.168.10.11',
  tokenName: 'EDU_WEB_TOKEN',
  tokenExpires: 60 * 60 * 1000 // token 过期时间为1个小时
}

// 根据环境变量覆盖默认配置
if (import.meta.env.MODE === 'development') {
  // 开发环境
  config = {
    ...config,
    // baseUrl: 'https://edu.shanxiyixue.com/gateway', // 开发网关地址
    // baseUrl: 'http://localhost:9900',
    baseUrl: 'http://192.168.10.139:9900', // 开发环境直接使用API服务器地址
    // url: 'text.ykumda.com' // 店铺域名，本地开发使用，生产不用配置该属性
    url: '192.168.10.139' 
    // url: 'aufe.ykumda.com' 
  }
}

// 允许从环境变量覆盖配置
if (import.meta.env.VITE_API_BASE_URL) {
  config.baseUrl = import.meta.env.VITE_API_BASE_URL
}

export default config 